import router from './index'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import qs from 'qs'

import wxMethod from '@/services/wx/wx'
import config from '@/config/index'

const getToken = () => {
  return localStorage.getItem('token_key') || ''
}

let pathName = String(window.location.hash)
    pathName = pathName.substring(1, pathName.length)
const query = qs.parse(pathName.split('?')[1] || '{}')
let newAppId = query.appid || config.appid;

const getAppId = () => {
  return localStorage.getItem('appId') || ''
}

NProgress.configure({ showSpinner: false }) // NProgress Configuration
const forceWxLogin = ['/app/downloads','/busCoupon','/pays','/paysend'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // determine whether the user has logged in
  // const hasToken = getToken() ;
  let hasToken = getToken() // todo
  let appid = getAppId()

  if(hasToken && hasToken.length < 20){
    hasToken = '';
    localStorage.setItem('token_key','')
  }

  if(appid != newAppId){
    hasToken = '';
    localStorage.setItem('token_key','')
  }

  // if(!appid || appid != newAppId){
  //   localStorage.setItem('appId',newAppId)
  // }

  // 强制登录路由 完全隔离
  const isNeedForce = !!forceWxLogin.filter(o => o.indexOf(to.path) > -1).length

  const forwardData = await wxMethod.checkAuthPageNeedRedirect(hasToken) // 检测是否为授权接收页

  //标题选取
  if (forwardData && forwardData.redirectURL) {
    document.title = config.projectName
  } else {
    document.title = to.meta.title
  }
  const queryParams = to.query
  
  if (isNeedForce) {
    if (queryParams.auth) {
      next()
      NProgress.done()
    } else {
      if(to.path == '/pays' || to.path == '/paysend'){
        next()
        NProgress.done()
      }else{
        const params = {
          params: {
            auth: 'ok'
          },
          path: encodeURIComponent(to.path),
          scope: 'snsapi_base'
        }
        wxMethod.authWx(params)
      }
      
    }
    return
  }

  if (hasToken) {
    if (forwardData && forwardData.redirectURL) {
      window.location.href = forwardData.redirectURL
    } else {
      next()
    }
    NProgress.done()
  } else {
    /* has no token */

    if (forwardData && forwardData.redirectURL) {
      window.location.href = forwardData.redirectURL
    } else {
      wxMethod.authWx()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
